import _ from 'lodash';
import moment from 'moment';
import styled from 'styled-components';
import { SHORT_DATE_FORMAT } from 'common/constants/constants';
import { getColor } from 'common/constants/_colors';
import { sizes } from 'styles/dropdown.style';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex, Padding } from 'components/base/layout-components';
import { PERIODS } from '../periods/constants';
import { lightColorPalette } from '@linearb/linui-common';

const StyledSelected = styled(Flex)`
  box-sizing: content-box;
  position: relative;
  ${({ highlight }) =>
    `border: 1px solid ${getColor(highlight ? 'orangePeel' : 'botticelli')};`}

  padding: 0.5rem 2.5rem 0.5rem 1rem !important;
  align-items: center;
  border-radius: 4px;
  ${({ disabled, highlight }) =>
    !disabled
      ? `
    :hover {
      cursor: pointer;
      border: 1px solid ${
        highlight ? lightColorPalette.lbOrangeDark : getColor('dodgerBlue')
      };
      background:${
        highlight ? lightColorPalette.lbOrange_5 : getColor('zircon')
      };
    }`
      : `
    background-color: ${lightColorPalette.lbBlue_5};
  `}
`;

const StyledPickerIcon = styled.div`
  right: 0.8rem;
  position: absolute;
  pointer-events: none;
`;

const PeriodSelected = ({
  currentPeriod,
  open,
  openMenu,
  size = 'medium',
  width,
  showCalendarIcon,
  disabled,
  show30daysMessage
}) => {
  const { before, after, periodKey, selectedName } = currentPeriod;
  const { menuName } = PERIODS[periodKey] || {};

  const { height, textSize, subtextSize, dropdownArrowSize } = _.get(
    sizes,
    [size],
    {}
  );
  const textSpaces = `2rem + ${dropdownArrowSize} + ${
    showCalendarIcon ? '2rem' : 0
  }`;

  if (!before || !after) {
    return null;
  }
  return (
    <StyledSelected
      height={height}
      grow='1'
      data-cy='period-picker-selected'
      onClick={open ? _.noop() : openMenu}
      disabled={disabled}
      highlight={show30daysMessage}
    >
      <Flex items='center'>
        {showCalendarIcon && (
          <Padding r='small' data-cy='period-picker-selected-icon'>
            <Icon
              name='calendaricon'
              size='medium'
              color={disabled ? 'silverSand' : 'nepal'}
            />
          </Padding>
        )}
        <Flex direction='column' maxWidth={`calc(${width} - (${textSpaces}))`}>
          <Text
            size={textSize}
            color={disabled ? 'silverSand' : 'shark'}
            ellipsisAfter='100%'
            data-cy='period-picker-selected-title'
          >
            {selectedName || menuName}
          </Text>
          <Text
            size={subtextSize}
            color={disabled ? 'silverSand' : 'shuttleGray'}
            ellipsisAfter='100%'
            data-cy='period-picker-selected-date-range'
          >
            {moment(after).format(SHORT_DATE_FORMAT)} -{' '}
            {moment(before).format(SHORT_DATE_FORMAT)}
          </Text>
        </Flex>
      </Flex>
      <StyledPickerIcon>
        <Icon
          name={open ? 'expandless' : 'expandmore'}
          color={disabled ? 'silverSand' : 'waikawaGray'}
          style={{ fontSize: dropdownArrowSize }}
        />
      </StyledPickerIcon>
    </StyledSelected>
  );
};

export default PeriodSelected;
